// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Scrollchor from 'react-scrollchor'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import Cover from '../cover'
import { DownloadComparison } from '../downloadcomparison'
import { Quote } from 'components/quote'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Waypoint } from 'react-waypoint'
import './styles.scss'

const ARTICLE_ID = '16407777'
const ADDITIONAL_SHARES = 567

document.addEventListener('DOMContentLoaded', function() {
  const xs = []
  for (let i = 0; i <= 200; i++) {
    xs.push(i)
  }

  let t = 0

  function animate() {
    const points = xs.map(x => {
      const y = 31 + 25 * Math.sin((x + t) / 10.8)
      return [x, y]
    })

    const pointsTwo = xs.map(x => {
      const y = 31 + 25 * Math.sin((x + t) / 14)
      return [x, y]
    })

    const path =
      'M' +
      pointsTwo
        .map(p => {
          return p[0] + ',' + p[1]
        })
        .join(' L')

    document.querySelector('path').setAttribute('d', path)

    const one =
      'M' +
      points
        .map(p => {
          return p[0] + ',' + p[1]
        })
        .join(' L')

    document.querySelector('#one').setAttribute('d', one)

    t += 0.4

    requestAnimationFrame(animate)
  }

  animate()
})

class AppComponent extends React.Component<Props> {
  constructor(props) {
    super(props)

    this.isMobile = window.innerWidth < 1200

    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
  }

  trackNavClicks(target) {
    const clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'NavFact: ' + clickedText
    })
  }

  trackTopClicks(target) {
    const clickedText = target
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: ' + clickedText
    })
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical fitted segment first'>
          <Cover title='Sieben Behauptungen zu 5G – was ist dran?' />
        </header>

        <div
          className='ui vertical fitted segment mobile hidden tablet hidden'
          style={{ padding: '0 0' }}
        >
          <div
            className={this.isMobile ? 'ui' : 'ui'}
            style={{
              backgroundImage: `url(${require('./imgs/header-desktop.svg')})`,
              // : `url(${require('./imgs/test-2.svg')})`,
              backgroundPosition: 'top center',
              height: '100%',
              paddingBottom: '20.40%',
              backgroundSize: '100% auto',
              backgroundRepeat: 'no-repeat',
              marginTop: '-1px'
              // paddingTop: this.isMobile ? '0' : '0em',
              // backgroundColor: this.isMobile ? 'transparent' : '#fff'
            }}
          />
        </div>

        <div
          className='ui vertical fitted segment mobile only'
          style={{ padding: '0 0' }}
        >
          <div
            className={this.isMobile ? 'ui' : 'ui'}
            style={{
              backgroundImage: `url(${require('./imgs/header-mobile.svg')})`,
              // : `url(${require('./imgs/test-2.svg')})`,
              backgroundPosition: 'top center',
              height: '100%',
              paddingBottom: '342.07011686%',
              backgroundSize: '100% auto',
              backgroundRepeat: 'no-repeat',
              marginTop: '7px'
              // paddingTop: this.isMobile ? '0' : '0em',
              // backgroundColor: this.isMobile ? 'transparent' : '#fff'
            }}
          />
        </div>

        <div
          className='ui vertical fitted segment tablet only'
          style={{ padding: '0 0' }}
        >
          <div
            className={this.isMobile ? 'ui' : 'ui'}
            style={{
              backgroundImage: `url(${require('./imgs/header-tablet.svg')})`,
              // : `url(${require('./imgs/test-2.svg')})`,
              backgroundPosition: 'top center',
              height: '100%',
              paddingBottom: '34.723%',
              backgroundSize: '100% auto',
              backgroundRepeat: 'no-repeat',
              marginTop: '-1px'
              // paddingTop: this.isMobile ? '0' : '0em',
              // backgroundColor: this.isMobile ? 'transparent' : '#fff'
            }}
          />
        </div>

        <div className='ui vertical fitted segment intro'>
          <div className='ui text container'>
            <p className='ta lead'>
              Der neue Mobilfunkstandard soll die Schweiz in die digitale
              Zukunft führen. Doch was bringt 5G der Wirtschaft wirklich? Und
              wie gefährlich ist die Strahlung? Das hyperschnelle Netz wird
              kontrovers diskutiert. Es schwirren viele Behauptungen umher. Hier
              sind die häufigsten. Dazu die Antworten.
            </p>
            <p className='ta author'>
              Von Yann Cherix, Felix Straumann, Viviane&nbsp;Futterknecht und
              Patrick&nbsp;Vögeli
            </p>
          </div>

          <div className='ui text container'>
            <ul className='nav' id='nav'>
              <p className='instruction'>
                Benützen Sie die Navigationshilfe oder scrollen Sie einfach
                durch die einzelnen Fakten.
              </p>

              <Scrollchor to='#question-1'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('1')}
                >
                  <li className='question-link'>
                    1. 5G verwendet völlig neue Frequenzen
                  </li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
              <Scrollchor to='#question-2'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('2')}
                >
                  <li className='question-link'>2. 5G ist krebserregend</li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
              <Scrollchor to='#question-3'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('3')}
                >
                  <li className='question-link'>
                    3. Ohne 5G gerät die Schweizer Wirtschaft ins Hintertreffen
                  </li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
              <Scrollchor to='#question-4'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('4')}
                >
                  <li className='question-link'>
                    4. Mehr Mobilfunk&shy;antennen steigern die
                    Strahlen&shy;belastung
                  </li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
              <Scrollchor to='#question-5'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('5')}
                >
                  <li className='question-link'>
                    5. 5G beeinflusst unsere Hirnströme
                  </li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
              <Scrollchor to='#question-6'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('6')}
                >
                  <li className='question-link'>
                    6. China und Russland bespitzeln uns
                  </li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
              <Scrollchor to='#question-7'>
                <div
                  className='question-container'
                  onClick={() => this.trackNavClicks('7')}
                >
                  <li className='question-link'>
                    7. Die Grenzwerte in der Schweiz sind strenger als im
                    Ausland
                  </li>
                  <i className='chevron down icon' />
                </div>
              </Scrollchor>
            </ul>
            <div className='mobile hidden infographic'>
              <FeedbackMessage
                mailTo='interaktiv@tamedia.ch'
                question='Haben Sie Anmerkungen oder einen Fehler entdeckt?'
              />
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container' id='question-1'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline'>1</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>
                    5G verwendet völlig neue Frequenzen
                  </span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo' />
                <div className='falseOne red' />
                <div className='neutral' />
                <div className='trueOne' />
                <div className='trueTwo' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>

            <p>
              Der Mobilfunk nutzt bis heute elektromagnetische Wellen mit einer
              Frequenz von 0,7 bis 2,7 Gigahertz (GHz). Die Frequenzen von 5G
              liegen vorerst nur leicht darüber bei 3,5 GHz. Zum Vergleich:
              Mikrowellenherde arbeiten mit rund 2,5 GHz, WLAN verwendet
              Frequenzen zwischen 2,4 und 5 GHz. In einem späteren Schritt
              dürfte 5G bei Frequenzen von 24 bis 40 GHz zur Anwendung kommen.
              Laut Bund wird dies aber erst abgeklärt. Alle diese Frequenzen
              zählen zu den sogenannten Mikrowellen. Darunter liegen die
              Radiowellen, darüber infrarotes Licht, das unter anderem bei
              Fernbedienungen verwendet wird.
            </p>
            <div className='frequenzWrapper'>
              <div className='ui grid stackable mobile reversed frequenz'>
                <div className='twelve wide column'>
                  <svg viewBox='0 0 210 60'>
                    <path d='M10,10 L50,100 L90,50' />
                  </svg>
                </div>

                <div className='four wide column'>
                  <h4 className='frequencyTitle'>4G LTE</h4>
                  <p className='frequencyDescription'>2,7 GHz</p>
                </div>
              </div>

              <div className='ui grid stackable mobile reversed frequenz'>
                <div className='twelve wide column'>
                  <svg viewBox='0 0 210 60'>
                    <path id='one' d='M10,10 L50,100 L90,50' />
                  </svg>
                </div>

                <div className='four wide column'>
                  <h4 className='frequencyTitle'>5G</h4>
                  <p className='frequencyDescription'>3,5 GHz</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '20ContentRead'
              })
            }
          }}
        />

        <div className='ui vertical fitted segment sectionBackground'>
          <div className='ui text container white space' id='question-2'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline white'>2</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>5G ist krebserregend</span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor white'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo' />
                <div className='falseOne red' />
                <div className='neutral' />
                <div className='trueOne' />
                <div className='trueTwo' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>
            <Quote side='left'>
              <img
                src={require('./imgs/gemuese.svg')}
                alt=''
                className='ui fluid image centered gemuese'
                style={{ maxWidth: '200px' }}
              />
            </Quote>
            <p>
              Die WHO bezeichnet Mobilfunkstrahlen als «möglicherweise
              krebserregend». Das gilt auch für 5G. Doch keine Panik. In der
              gleichen Kategorie befinden sich Nahrungsmittel, die wir täglich
              bedenkenlos konsumieren und sogar für gesund halten. Die
              WHO-Einteilung bedeutet, dass eine Krebswirkung derzeit nicht
              ausgeschlossen werden kann, doch auch bewiesen ist sie nicht.
              Hinweise auf eine mögliche Karzinogenität waren bislang immer
              zweifelhaft und konnten nie bestätigt werden. Zudem: Obwohl seit
              20 Jahren mehr als die Hälfte der Europäer ein Handy benutzt, ist
              es bis heute zu keiner Zunahme von Hirntumoren gekommen.
            </p>
          </div>
        </div>

        <div className='ui vertical fitted segment sectionBackgroundTwo'>
          <div className='ui text container space' id='question-3'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline'>3</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>
                    Ohne 5G gerät die Schweiz ins Hintertreffen
                  </span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo' />
                <div className='falseOne' />
                <div className='neutral' />
                <div className='trueOne red' />
                <div className='trueTwo' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>

            <Quote side='right'>
              <img
                src={require('./imgs/drohne.svg')}
                alt=''
                className='ui fluid image centered drohne'
                style={{ maxWidth: '200px' }}
              />
            </Quote>

            <p>
              Autonomes Fahren, Drohnenlieferungen, intelligente Kühlschränke:
              Diese zukunftsträchtigen Dinge brauchen einen sehr schnellen
              Datentransport. Für die Industrie, die der grösste Profiteur der
              Neuerung sein wird, ist klar, dass die Schweiz zum 5G-Land werden
              muss. Deutschland ist im Vergleich zur Schweiz in Sachen
              Netzausbau ein Entwicklungsland, Südkorea ist Spitzenreiter. Stand
              jetzt ist, dass das hiesige Glasfasernetz ausreicht. Die Frage
              lautet aber: Ist es auch schnell genug für die Zukunft? Wohl eher
              nicht.
            </p>
            <DownloadComparison
              title='Downloadgeschwindigkeiten im Vergleich'
              subtitle='Herunterladen eines 800 MB Spielfilms, bei Idealbedingungen'
              source='Swisscom, eigene Recherche'
            />
          </div>
        </div>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '50ContentRead'
              })
            }
          }}
        />

        <div className='ui vertical fitted segment wave'>
          <img
            src={require('./imgs/wave.svg')}
            alt=''
            className='ui fluid image mobile hidden'
          />
          <img
            src={require('./imgs/wave-mobile.svg')}
            alt=''
            className='ui fluid image mobile only'
          />
        </div>

        <div className='ui vertical fitted segment'>
          <div className='ui text container spaceTwo' id='question-4'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline'>4</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>
                    Mehr Mobilfunkantennen steigern die Strahlenbelastung
                  </span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo red' />
                <div className='falseOne' />
                <div className='neutral' />
                <div className='trueOne' />
                <div className='trueTwo' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>
            <Quote side='left'>
              <img
                src={require('./imgs/headphones.svg')}
                alt=''
                className='ui fluid image centered headphones'
                style={{ maxWidth: '200px' }}
              />
            </Quote>
            <p>
              Was die Strahlenbelastung betrifft, ist der Widerstand gegen neue
              Antennen oder höhere Grenzwerte kontraproduktiv. Das ist mit 5G
              nicht anders als bei älteren Standards. Der grösste Teil der
              Strahlung stammt nicht von Antennen, sondern vom eigenen
              Smartphone ‒ vorausgesetzt, man besitzt eines. Und je schlechter
              der Empfang, desto höher die Belastung. Darum ist die Strahlung im
              Zug am stärksten: Die Leute sind am Mobiltelefon, das sich mit
              immer wieder neuen Antennen draussen verbindet. Grundsätzlich
              gilt: Eine Verdoppelung der Distanz zur Strahlungsquelle halbiert
              die Feldstärke. Deshalb sinkt auch die Belastung, wenn mit
              Kopfhörer telefoniert wird.
            </p>

            <AutofitIFrame
              title='Strahlenexposition durch Mobilfunk'
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/Eu6l3/1/'
            />
          </div>
        </div>

        <div className='ui vertical fitted segment sectionBackground'>
          <div className='ui text container white space' id='question-5'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline white'>5</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>
                    5G beeinflusst unsere Hirnströme
                  </span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor white'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon white' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo' />
                <div className='falseOne' />
                <div className='neutral' />
                <div className='trueOne' />
                <div className='trueTwo red' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>

            <p>
              <Quote side='right'>
                <img
                  src={require('./imgs/gehirn.png')}
                  alt=''
                  className='ui fluid image centered gehirn'
                  style={{ maxWidth: '200px' }}
                />
              </Quote>
              Studien an Menschen belegen, dass Handynutzung (nicht jedoch die
              schwächere Strahlung von Mobilfunkantennen) Hirnströme und
              geistige Funktionen beeinflussen kann. Unklar ist, wie das zu
              interpretieren ist. Auch Filme gucken oder eine Tasse Kaffee
              verändern Hirnströme. In Laborversuchen finden sich weitere
              biologische Effekte durch Mobilfunkstrahlung. Ob und wie sich dies
              langfristig auf die Gesundheit auswirkt, ist unklar. Eine
              Besonderheit bei 5G ist, dass die Strahlen mit ihren höheren
              Frequenzen weniger tief ins Gewebe eindringen können. Unbestritten
              ist, dass Mobilfunkstrahlung eine schädliche Wärmewirkung
              entfalten kann. Dies allerdings erst ab einer Strahlungsstärke,
              die deutlich über den Grenzwerten liegt.
            </p>
          </div>
        </div>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === Waypoint.below) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '75ContentRead'
              })
            }
          }}
        />

        <div className='ui vertical fitted segment sectionBackgroundTwo'>
          <div className='ui text container space' id='question-6'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline'>6</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>
                    China und Russland
                    <br /> bespitzeln uns
                  </span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo' />
                <div className='falseOne' />
                <div className='neutral red' />
                <div className='trueOne' />
                <div className='trueTwo' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>
            <p>
              <Quote side='left'>
                <img
                  src={require('./imgs/spion.svg')}
                  alt=''
                  className='ui fluid image centered spion'
                  style={{ maxWidth: '180px' }}
                />
              </Quote>
              Es scheint so, dass Russland, ein 5G-Entwicklungsland, gezielt
              Falschinformationen (Gesundheitsschädlichkeit) platziert, um dem
              Westen die Technologie zu vermiesen. Ein Grund: wirtschaftliche
              Kriegsführung, um nicht abgehängt zu werden. Diffus ist die Rolle
              Chinas. Fakt ist, dass das chinesische Unternehmen Huawei der
              Swisscom Festnetzbestandteile liefert und der Sunrise beim 5G-Netz
              hilft. Beweise, dass Huawei dies für Spionage nützt, gibt es
              bisher keine. Nur: Chinas Regierung und chinesische Unternehmen
              sind eng miteinander verbunden. Immer wieder heisst es, Letztere
              spionierten in Diensten des Staates (US-Boykott). Im Juli wurde
              abermals ein Spionagefall mit Beteiligung von Huawei-Mitarbeitern
              bekannt. Diesmal in Tschechien. Grundsätzlich gilt aber: Es
              besteht eine Abhängigkeit bei jeglicher Netzwerktechnik. Auch die
              USA könnten uns abhören, wie Edward Snowden aufgedeckt hat.
            </p>
          </div>
        </div>

        <div className='ui vertical fitted segment wave'>
          <img
            src={require('./imgs/wave.svg')}
            alt=''
            className='ui fluid image mobile hidden'
          />
          <img
            src={require('./imgs/wave-mobile.svg')}
            alt=''
            className='ui fluid image mobile only'
          />
        </div>

        <div className='ui vertical fitted segment karte'>
          <div className='ui text container spaceTwo' id='question-7'>
            <div className='titleWrapper'>
              <h2 className='questionTitleWrapper'>
                <span className='titleOutline'>7</span>
              </h2>

              <div className='innerWrapper'>
                <div className='leftSpace' />
                <h2 className='questionTitleWrapper'>
                  <span className='titleText'>
                    Die Grenzwerte in der Schweiz sind strenger als im Ausland
                  </span>
                </h2>
                <Scrollchor to='#nav' className='upScrollchor'>
                  <div
                    className='top-link'
                    onClick={() => this.trackTopClicks('menu')}
                  >
                    <div
                      className='arrow-text mobile hidden'
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      nach oben
                    </div>{' '}
                    <i className='chevron up icon' />
                  </div>
                </Scrollchor>
              </div>
            </div>
            <div className='scaleContainer'>
              <div className='scaleWrapper'>
                <div className='falseTwo' />
                <div className='falseOne' />
                <div className='neutral' />
                <div className='trueOne red' />
                <div className='trueTwo' />
              </div>
              <div className='textWrapper'>
                <div className='textFalse'>Falsch</div>
                <div className='textFalse'>Richtig</div>
              </div>
            </div>

            <p>
              Bei den Mobilfunkantennen gelten in der Schweiz grundsätzlich
              Immissionsgrenzwerte (IGW). Diese messen die Strahlung aller
              Sendeanlagen, die an einem von Menschen frequentierten Ort
              eintreffen dürfen. Es sind die gleichen Werte wie in den meisten
              Nachbarländern. Strenger als in vielen Ländern sind in der Schweiz
              die Anlagegrenzwerte, die an Orten gelten, an denen sich Menschen
              längere Zeit aufhalten, und zehnmal tiefer liegen als die IGW.
            </p>
            <div>
              <p className='graphic title lauftext'>
                <strong>Beispiel einer Antenne in 20 Meter Höhe</strong>
              </p>
              <img
                src={require('./imgs/antenne-desktop.svg')}
                alt=''
                className='ui fluid image mobile hidden'
              />
              <img
                src={require('./imgs/antenne-mobile.svg')}
                alt=''
                className='ui fluid image mobile only'
              />
              <p className='graphicByline'>
                Die Strahlung ist mehrheitlich in eine bestimmte Richtung
                gebündelt. Mit zunehmendem Abstand sinkt die elektrische
                Feldstärke.
              </p>
              <img
                src={require('./imgs/antenne-desktop-2.svg')}
                alt=''
                className='ui fluid image mobile hidden'
              />
              <img
                src={require('./imgs/antenne-mobile-2.svg')}
                alt=''
                className='ui fluid image mobile only'
              />
            </div>
          </div>
        </div>

        <div className='ui vertical fitted segment sectionBackground last'>
          {/* TODO Add your credits in this component */}
          <Footer
            articleId={ARTICLE_ID}
            additionalShares={ADDITIONAL_SHARES}
            starColor='yellow'
            questions={[
              'Wie informativ war der Beitrag?',
              'Wie unterhaltsam war er?',
              'Wie gefällt Ihnen die Gestaltung?'
            ]}
            credits={[
              ['Text und Recherche', 'Yann Cherix und Felix Straumann'],
              ['Illustrationen', 'Viviane Futterknecht'],
              [
                'Digitale Umsetzung und Programmierung',
                'Patrick Vögeli, Interaktiv-Team'
              ],
              [
                'Quellen',
                'Bafu, BAG, BAKOM, Beobachter, Functional-Basics, Hausarzt Praxis, IARC, gmo-answers, compoundchem, pctipp.ch, Publikation Rössler, Wikipedia'
              ]
            ]}
            invertedTop
            topHalfClassName='basic'
          />
        </div>
      </div>
    )
  }
}

export default hot(module)(AppComponent)
